import PageHeader from "../../components/common/ui/PageHeader";

const CCTVBox = ({ src }) => {
  const now = new Date().toLocaleString("ko-KR");

  return (
    <div
      style={{
        position: "relative",
        background: "black",
        borderRadius: "6px",
        overflow: "hidden",
        boxShadow: "0 0 10px rgba(0,0,0,0.5)",
      }}
    >
      {/* REC */}
      <div
        style={{
          position: "absolute",
          top: 8,
          left: 8,
          color: "red",
          fontWeight: "bold",
          fontSize: "12px",
          zIndex: 2,
        }}
      >
        ● REC
      </div>

      {/* 시간 */}
      <div
        style={{
          position: "absolute",
          top: 8,
          right: 8,
          color: "white",
          fontSize: "12px",
          zIndex: 2,
        }}
      >
        {now}
      </div>

      {/* 이미지 */}
      <img
        src={src}
        alt=""
        style={{
          width: "100%",
          height: "300px",
          objectFit: "cover",
          filter: "grayscale(20%) contrast(105%) brightness(85%)",
        }}
      />

      {/* 노이즈 */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "repeating-linear-gradient(transparent 0px, rgba(0,0,0,0.04) 2px, transparent 4px)",
          pointerEvents: "none",
        }}
      />
    </div>
  );
};

const Live = () => {
  // 각 CCTV마다 다른 이미지
  const img1 =
    "https://pds.joongang.co.kr/news/component/htmlphoto_mmdata/202308/23/831195e3-1e30-4d14-8f4c-43b3ed48e818.jpg";
  const img2 =
    "https://img4.yna.co.kr/etc/inner/KR/2021/06/07/AKR20210607093900052_01_i_P4.jpg";
  const img3 =
    "https://cdn.sisajournal.com/news/photo/202509/346642_352671_408.jpg";
  const img4 =
    "https://m.imaeil.com/photos/2025/08/31/2025083115470309148_l.jpg";

  return (
    <div className="p-6">
      <PageHeader>실시간 안전 관리</PageHeader>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "12px",
          width: "80%",
        }}
      >
        <CCTVBox src={img1} />
        <CCTVBox src={img2} />
        <CCTVBox src={img3} />
        <CCTVBox src={img4} />
      </div>
    </div>
  );
};

export default Live;
